export const PRODUCT_DESCRIPTION_MAX_LENGTH: number = 1024
